export default __webpack_public_path__ + "static/media/CGU_Mentions_Legales.94395efa.pdf";